// Super admin -> Global Data (`super_admin/GlobalDataView.jsx`, `globalDataTabs.jsx`):
// every label of the twelve cross-practice tables, one key per status value per tab.
// docs/auth-and-admin/global-data-contract.md section 4.
export default {
  fr: {
    "gdv.title": "Données globales",
    "gdv.subtitle": "Vue de tous les cabinets : clients, RDV, programmes, médias, identités visuelles, facturation, contenus.",
    "gdv.search.customers": "Rechercher par nom, email ou téléphone...",
    "gdv.search.bookings": "Rechercher par patient, email, référence ou service...",
    "gdv.search.programs": "Rechercher par nom de programme...",
    "gdv.search.promos": "Rechercher par code...",
    "gdv.search.giftcards": "Rechercher par code ou email du bénéficiaire...",
    "gdv.search.media": "Rechercher par nom de fichier...",
    "gdv.search.content": "Rechercher par clé ou texte...",
    "gdv.search.blog": "Rechercher par titre ou slug...",
    "gdv.search.billing": "Rechercher par référence ou plan...",
    "gdv.search.invoices": "Rechercher par client, email ou numéro de facture...",
    "gdv.search.branding": "Rechercher par nom ou slug du cabinet...",
    "gdv.search.insights": "Rechercher dans le texte du briefing...",
    "gdv.empty": "Aucun résultat.",
    "gdv.tab.customers": "Clients (CRM)",
    "gdv.tab.bookings": "Calendrier (RDV)",
    "gdv.tab.programs": "Programmes",
    "gdv.tab.promos": "Promos",
    "gdv.tab.giftcards": "Cartes cadeaux",
    "gdv.tab.media": "Médias",
    "gdv.tab.content": "Contenu site",
    "gdv.tab.blog": "Articles",
    "gdv.tab.billing": "Facturation",
    "gdv.tab.invoices": "Factures",
    "gdv.tab.branding": "Identité visuelle",
    "gdv.tab.insights": "Analyses IA",
    "gdv.h.name": "Nom",
    "gdv.h.email": "Email",
    "gdv.h.phone": "Téléphone",
    "gdv.h.tenant": "Cabinet",
    "gdv.h.registered": "Inscrit",
    "gdv.h.patient": "Patient",
    "gdv.h.service": "Service",
    "gdv.h.status": "Statut",
    "gdv.h.date": "Date",
    "gdv.h.title": "Titre",
    "gdv.h.duration": "Durée",
    "gdv.h.price": "Prix",
    "gdv.h.code": "Code",
    "gdv.h.discount": "Remise",
    "gdv.h.uses": "Utilisations",
    "gdv.h.amount": "Montant",
    "gdv.h.balance": "Solde",
    "gdv.h.recipient": "Bénéficiaire",
    "gdv.h.preview": "Aperçu",
    "gdv.h.file": "Fichier",
    "gdv.h.type": "Type",
    "gdv.h.size": "Taille",
    "gdv.h.key": "Clé",
    "gdv.h.textFr": "Texte FR",
    "gdv.h.textEn": "Texte EN",
    "gdv.h.tag": "Tag",
    "gdv.h.created": "Créé",
    "gdv.h.id": "ID",
    "gdv.h.plan": "Plan",
    "gdv.h.number": "N°",
    "gdv.invoiceNumber.draft": "Brouillon",
    "gdv.invoiceNumber.receipt": "Reçu {number}",
    "gdv.h.client": "Client",
    "gdv.h.logo": "Logo",
    "gdv.h.palette": "Palette",
    "gdv.h.font": "Police",
    "gdv.h.domain": "Domaine",
    "gdv.h.briefing": "Briefing",
    "gdv.h.generatedOn": "Généré le",
    "gdv.allStatuses": "Tous les statuts",
    "gdv.total": "{total} résultats",
    "gdv.totalOne": "{total} résultat",
    "gdv.expand": "Voir tout",
    "gdv.collapse": "Réduire",
    "gdv.featured": "En vedette",
    "gdv.domainStatus.pending_dns": "en attente du DNS",
    "gdv.domainStatus.provisioning": "sécurisation",
    "gdv.domainStatus.live": "en ligne",
    "gdv.domainStatus.failed": "échec",
    "gdv.domainStatus.lapsed": "déconnecté",
    "gdv.h.expires": "Expire",
    "gdv.expiryUnreadable": "Date illisible",
    "gdv.h.initial": "Valeur initiale",
    "gdv.h.source": "Origine",
    "gdv.h.updated": "Modifié",
    "gdv.h.likes": "J'aime",
    "gdv.h.provider": "Prestataire",
    "gdv.h.paidOn": "Payée le",
    "gdv.h.tagline": "Slogan",
    "gdv.status.customers.lead": "Prospect",
    "gdv.status.customers.active": "Actif",
    "gdv.status.customers.past": "Ancien",
    "gdv.status.bookings.pending": "En attente",
    "gdv.status.bookings.pending_payment": "Paiement en attente",
    "gdv.status.bookings.confirmed": "Confirmé",
    "gdv.status.bookings.paid_needs_attention": "Payé, à traiter",
    "gdv.status.bookings.cancelled": "Annulé",
    "gdv.status.bookings.completed": "Terminé",
    "gdv.status.bookings.no_show": "Absent",
    "gdv.status.programs.active": "Actif",
    "gdv.status.programs.inactive": "Inactif",
    "gdv.status.promos.active": "Actif",
    "gdv.status.promos.inactive": "Inactif",
    "gdv.status.promos.expired": "Expiré",
    "gdv.status.giftcards.active": "Active",
    "gdv.status.giftcards.partially_redeemed": "Partiellement utilisée",
    "gdv.status.giftcards.redeemed": "Utilisée",
    "gdv.status.giftcards.cancelled": "Annulée",
    "gdv.status.giftcards.refunded": "Remboursée",
    "gdv.status.media.image": "Image",
    "gdv.status.media.video": "Vidéo",
    "gdv.status.media.document": "Document",
    "gdv.status.media.file": "Fichier",
    "gdv.status.blog.published": "Publié",
    "gdv.status.blog.draft": "Brouillon",
    "gdv.status.billing.initiated": "Initié",
    "gdv.status.billing.completed": "Terminé",
    "gdv.status.billing.failed": "Échoué",
    "gdv.status.billing.expired": "Expiré",
    "gdv.status.billing.pending": "En attente",
    "gdv.status.billing.refunded": "Remboursé",
    "gdv.status.billing.refund_unverified": "Remboursement non vérifié",
    "gdv.status.invoices.draft": "Brouillon",
    "gdv.status.invoices.sent": "Envoyée",
    "gdv.status.invoices.paid": "Payée",
    "gdv.status.invoices.cancelled": "Annulée",
    "gdv.status.invoices.refunded": "Remboursée",
    "gdv.status.invoices.overdue_notified": "Relance envoyée",
    "gdv.status.insights.ai": "IA",
    "gdv.status.insights.fallback": "Secours",
    "gdv.insights.reason.not_configured": "IA non configurée",
    "gdv.insights.reason.ai_error": "Échec de l'appel IA",
    "gdv.source.admin": "Admin",
    "gdv.source.sold": "Vendue",
    "gdv.visibility.public": "Public",
    "gdv.visibility.private": "Privé",
  },
  en: {
    "gdv.title": "Global data",
    "gdv.subtitle": "Cross-tenant view: all clients, appointments, programs, media, brandings, billing, content.",
    "gdv.search.customers": "Search by name, email or phone...",
    "gdv.search.bookings": "Search by patient, email, reference or service...",
    "gdv.search.programs": "Search by program name...",
    "gdv.search.promos": "Search by code...",
    "gdv.search.giftcards": "Search by code or recipient email...",
    "gdv.search.media": "Search by file name...",
    "gdv.search.content": "Search by key or text...",
    "gdv.search.blog": "Search by title or slug...",
    "gdv.search.billing": "Search by reference or plan...",
    "gdv.search.invoices": "Search by client, email or invoice number...",
    "gdv.search.branding": "Search by practice name or slug...",
    "gdv.search.insights": "Search the briefing text...",
    "gdv.empty": "No results.",
    "gdv.tab.customers": "Clients (CRM)",
    "gdv.tab.bookings": "Calendar (appointments)",
    "gdv.tab.programs": "Programs",
    "gdv.tab.promos": "Promos",
    "gdv.tab.giftcards": "Gift cards",
    "gdv.tab.media": "Media",
    "gdv.tab.content": "Site content",
    "gdv.tab.blog": "Articles",
    "gdv.tab.billing": "Billing",
    "gdv.tab.invoices": "Invoices",
    "gdv.tab.branding": "Branding",
    "gdv.tab.insights": "AI Insights",
    "gdv.h.name": "Name",
    "gdv.h.email": "Email",
    "gdv.h.phone": "Phone",
    "gdv.h.tenant": "Practice",
    "gdv.h.registered": "Registered",
    "gdv.h.patient": "Patient",
    "gdv.h.service": "Service",
    "gdv.h.status": "Status",
    "gdv.h.date": "Date",
    "gdv.h.title": "Title",
    "gdv.h.duration": "Duration",
    "gdv.h.price": "Price",
    "gdv.h.code": "Code",
    "gdv.h.discount": "Discount",
    "gdv.h.uses": "Uses",
    "gdv.h.amount": "Amount",
    "gdv.h.balance": "Balance",
    "gdv.h.recipient": "Recipient",
    "gdv.h.preview": "Preview",
    "gdv.h.file": "File",
    "gdv.h.type": "Type",
    "gdv.h.size": "Size",
    "gdv.h.key": "Key",
    "gdv.h.textFr": "Text FR",
    "gdv.h.textEn": "Text EN",
    "gdv.h.tag": "Tag",
    "gdv.h.created": "Created",
    "gdv.h.id": "ID",
    "gdv.h.plan": "Plan",
    "gdv.h.number": "No.",
    "gdv.invoiceNumber.draft": "Draft",
    "gdv.invoiceNumber.receipt": "Receipt {number}",
    "gdv.h.client": "Client",
    "gdv.h.logo": "Logo",
    "gdv.h.palette": "Palette",
    "gdv.h.font": "Font",
    "gdv.h.domain": "Domain",
    "gdv.h.briefing": "Briefing",
    "gdv.h.generatedOn": "Generated on",
    "gdv.allStatuses": "All statuses",
    "gdv.total": "{total} results",
    "gdv.totalOne": "{total} result",
    "gdv.expand": "Show all",
    "gdv.collapse": "Collapse",
    "gdv.featured": "Featured",
    "gdv.domainStatus.pending_dns": "waiting for DNS",
    "gdv.domainStatus.provisioning": "securing",
    "gdv.domainStatus.live": "live",
    "gdv.domainStatus.failed": "failed",
    "gdv.domainStatus.lapsed": "disconnected",
    "gdv.h.expires": "Expires",
    "gdv.expiryUnreadable": "Unreadable date",
    "gdv.h.initial": "Initial value",
    "gdv.h.source": "Source",
    "gdv.h.updated": "Updated",
    "gdv.h.likes": "Likes",
    "gdv.h.provider": "Provider",
    "gdv.h.paidOn": "Paid on",
    "gdv.h.tagline": "Tagline",
    "gdv.status.customers.lead": "Lead",
    "gdv.status.customers.active": "Active",
    "gdv.status.customers.past": "Past",
    "gdv.status.bookings.pending": "Pending",
    "gdv.status.bookings.pending_payment": "Awaiting payment",
    "gdv.status.bookings.confirmed": "Confirmed",
    "gdv.status.bookings.paid_needs_attention": "Paid, needs attention",
    "gdv.status.bookings.cancelled": "Cancelled",
    "gdv.status.bookings.completed": "Completed",
    "gdv.status.bookings.no_show": "No-show",
    "gdv.status.programs.active": "Active",
    "gdv.status.programs.inactive": "Inactive",
    "gdv.status.promos.active": "Active",
    "gdv.status.promos.inactive": "Inactive",
    "gdv.status.promos.expired": "Expired",
    "gdv.status.giftcards.active": "Active",
    "gdv.status.giftcards.partially_redeemed": "Partially redeemed",
    "gdv.status.giftcards.redeemed": "Redeemed",
    "gdv.status.giftcards.cancelled": "Cancelled",
    "gdv.status.giftcards.refunded": "Refunded",
    "gdv.status.media.image": "Image",
    "gdv.status.media.video": "Video",
    "gdv.status.media.document": "Document",
    "gdv.status.media.file": "File",
    "gdv.status.blog.published": "Published",
    "gdv.status.blog.draft": "Draft",
    "gdv.status.billing.initiated": "Initiated",
    "gdv.status.billing.completed": "Completed",
    "gdv.status.billing.failed": "Failed",
    "gdv.status.billing.expired": "Expired",
    "gdv.status.billing.pending": "Pending",
    "gdv.status.billing.refunded": "Refunded",
    "gdv.status.billing.refund_unverified": "Refund unverified",
    "gdv.status.invoices.draft": "Draft",
    "gdv.status.invoices.sent": "Sent",
    "gdv.status.invoices.paid": "Paid",
    "gdv.status.invoices.cancelled": "Cancelled",
    "gdv.status.invoices.refunded": "Refunded",
    "gdv.status.invoices.overdue_notified": "Overdue (reminded)",
    "gdv.status.insights.ai": "AI",
    "gdv.status.insights.fallback": "Fallback",
    "gdv.insights.reason.not_configured": "AI not configured",
    "gdv.insights.reason.ai_error": "AI call failed",
    "gdv.source.admin": "Admin",
    "gdv.source.sold": "Sold",
    "gdv.visibility.public": "Public",
    "gdv.visibility.private": "Private",
  },
  es: {
    "gdv.title": "Datos globales",
    "gdv.subtitle": "Vista de todas las consultas: clientes, citas, programas, medios, identidades visuales, facturación, contenidos.",
    "gdv.search.customers": "Buscar por nombre, email o teléfono...",
    "gdv.search.bookings": "Buscar por paciente, email, referencia o servicio...",
    "gdv.search.programs": "Buscar por nombre de programa...",
    "gdv.search.promos": "Buscar por código...",
    "gdv.search.giftcards": "Buscar por código o email del beneficiario...",
    "gdv.search.media": "Buscar por nombre de archivo...",
    "gdv.search.content": "Buscar por clave o texto...",
    "gdv.search.blog": "Buscar por título o slug...",
    "gdv.search.billing": "Buscar por referencia o plan...",
    "gdv.search.invoices": "Buscar por cliente, email o número de factura...",
    "gdv.search.branding": "Buscar por nombre o slug de la consulta...",
    "gdv.search.insights": "Buscar en el texto del briefing...",
    "gdv.empty": "Ningún resultado.",
    "gdv.tab.customers": "Clientes (CRM)",
    "gdv.tab.bookings": "Calendario (citas)",
    "gdv.tab.programs": "Programas",
    "gdv.tab.promos": "Promos",
    "gdv.tab.giftcards": "Tarjetas regalo",
    "gdv.tab.media": "Medios",
    "gdv.tab.content": "Contenido del sitio",
    "gdv.tab.blog": "Artículos",
    "gdv.tab.billing": "Facturación",
    "gdv.tab.invoices": "Facturas",
    "gdv.tab.branding": "Identidad visual",
    "gdv.tab.insights": "Análisis IA",
    "gdv.h.name": "Nombre",
    "gdv.h.email": "Email",
    "gdv.h.phone": "Teléfono",
    "gdv.h.tenant": "Consulta",
    "gdv.h.registered": "Registrado",
    "gdv.h.patient": "Paciente",
    "gdv.h.service": "Servicio",
    "gdv.h.status": "Estado",
    "gdv.h.date": "Fecha",
    "gdv.h.title": "Título",
    "gdv.h.duration": "Duración",
    "gdv.h.price": "Precio",
    "gdv.h.code": "Código",
    "gdv.h.discount": "Descuento",
    "gdv.h.uses": "Usos",
    "gdv.h.amount": "Importe",
    "gdv.h.balance": "Saldo",
    "gdv.h.recipient": "Beneficiario",
    "gdv.h.preview": "Vista previa",
    "gdv.h.file": "Archivo",
    "gdv.h.type": "Tipo",
    "gdv.h.size": "Tamaño",
    "gdv.h.key": "Clave",
    "gdv.h.textFr": "Texto FR",
    "gdv.h.textEn": "Texto EN",
    "gdv.h.tag": "Etiqueta",
    "gdv.h.created": "Creado",
    "gdv.h.id": "ID",
    "gdv.h.plan": "Plan",
    "gdv.h.number": "N.º",
    "gdv.invoiceNumber.draft": "Borrador",
    "gdv.invoiceNumber.receipt": "Recibo {number}",
    "gdv.h.client": "Cliente",
    "gdv.h.logo": "Logo",
    "gdv.h.palette": "Paleta",
    "gdv.h.font": "Fuente",
    "gdv.h.domain": "Dominio",
    "gdv.h.briefing": "Briefing",
    "gdv.h.generatedOn": "Generado el",
    "gdv.allStatuses": "Todos los estados",
    "gdv.total": "{total} resultados",
    "gdv.totalOne": "{total} resultado",
    "gdv.expand": "Ver todo",
    "gdv.collapse": "Contraer",
    "gdv.featured": "Destacado",
    "gdv.domainStatus.pending_dns": "esperando el DNS",
    "gdv.domainStatus.provisioning": "protegiendo",
    "gdv.domainStatus.live": "en línea",
    "gdv.domainStatus.failed": "error",
    "gdv.domainStatus.lapsed": "desconectado",
    "gdv.h.expires": "Caduca",
    "gdv.expiryUnreadable": "Fecha ilegible",
    "gdv.h.initial": "Valor inicial",
    "gdv.h.source": "Origen",
    "gdv.h.updated": "Modificado",
    "gdv.h.likes": "Me gusta",
    "gdv.h.provider": "Proveedor",
    "gdv.h.paidOn": "Pagada el",
    "gdv.h.tagline": "Eslogan",
    "gdv.status.customers.lead": "Prospecto",
    "gdv.status.customers.active": "Activo",
    "gdv.status.customers.past": "Anterior",
    "gdv.status.bookings.pending": "Pendiente",
    "gdv.status.bookings.pending_payment": "Pago pendiente",
    "gdv.status.bookings.confirmed": "Confirmada",
    "gdv.status.bookings.paid_needs_attention": "Pagada, requiere atención",
    "gdv.status.bookings.cancelled": "Cancelada",
    "gdv.status.bookings.completed": "Completada",
    "gdv.status.bookings.no_show": "No se presentó",
    "gdv.status.programs.active": "Activo",
    "gdv.status.programs.inactive": "Inactivo",
    "gdv.status.promos.active": "Activo",
    "gdv.status.promos.inactive": "Inactivo",
    "gdv.status.promos.expired": "Caducado",
    "gdv.status.giftcards.active": "Activa",
    "gdv.status.giftcards.partially_redeemed": "Parcialmente canjeada",
    "gdv.status.giftcards.redeemed": "Canjeada",
    "gdv.status.giftcards.cancelled": "Cancelada",
    "gdv.status.giftcards.refunded": "Reembolsada",
    "gdv.status.media.image": "Imagen",
    "gdv.status.media.video": "Vídeo",
    "gdv.status.media.document": "Documento",
    "gdv.status.media.file": "Archivo",
    "gdv.status.blog.published": "Publicado",
    "gdv.status.blog.draft": "Borrador",
    "gdv.status.billing.initiated": "Iniciado",
    "gdv.status.billing.completed": "Completado",
    "gdv.status.billing.failed": "Fallido",
    "gdv.status.billing.expired": "Caducado",
    "gdv.status.billing.pending": "Pendiente",
    "gdv.status.billing.refunded": "Reembolsado",
    "gdv.status.billing.refund_unverified": "Reembolso sin verificar",
    "gdv.status.invoices.draft": "Borrador",
    "gdv.status.invoices.sent": "Enviada",
    "gdv.status.invoices.paid": "Pagada",
    "gdv.status.invoices.cancelled": "Cancelada",
    "gdv.status.invoices.refunded": "Reembolsada",
    "gdv.status.invoices.overdue_notified": "Vencida (recordada)",
    "gdv.status.insights.ai": "IA",
    "gdv.status.insights.fallback": "Respaldo",
    "gdv.insights.reason.not_configured": "IA no configurada",
    "gdv.insights.reason.ai_error": "Falló la llamada a IA",
    "gdv.source.admin": "Admin",
    "gdv.source.sold": "Vendida",
    "gdv.visibility.public": "Público",
    "gdv.visibility.private": "Privado",
  },
};
